export class PaymentMethod {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.sequence = params.sequence ? params.sequence : null
    this.name = params.name ? params.name : null
    this.attributes = params.attributes ? params.attributes : null
    this.editable = params.editable ? params.editable : false
  }
}
